import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Navbar.css';

const Navbar = () => {
  const [isNavCollapsed, setIsNavCollapsed] = useState(true);
  const [activeCategory, setActiveCategory] = useState(null);
  const [hoveredCategory, setHoveredCategory] = useState(null);

  const handleNavCollapse = () => setIsNavCollapsed(!isNavCollapsed);

  const categories = [
    {
      name: 'Exide',
      path: '/exide-products',
      icon: 'fa-bolt',
      subcategories: [
        { name: 'Motor Cycle Battery', path: '/exide-products?category=motor-cycle' },
        { name: 'Car Battery', path: '/exide-products?category=car' },
        { name: 'Heavy Vehicle Battery', path: '/exide-products?category=heavy-vehicles' },
        { name: 'Inverter Battery', path: '/exide-products?category=inverter' },
        { name: 'Solar Battery', path: '/exide-products?category=solar' }
      ]
    },
    {
      name: 'Luminous',
      path: '/luminous-products',
      icon: 'fa-sun',
      subcategories: [
        { name: 'Motor Cycle Battery', path: '/luminous-products?category=motor-cycle' },
        { name: 'Car Battery', path: '/luminous-products?category=car' },
        { name: 'Inverter Battery', path: '/luminous-products?category=inverter' },
        { name: 'Solar Battery', path: '/luminous-products?category=solar' }
      ]
    },
    {
      name: 'Amaron',
      path: '/amaron-products',
      icon: 'fa-car-battery',
      subcategories: [
        { name: 'Motor Cycle Battery', path: '/amaron-products?category=motor-cycle' },
        { name: 'Car Battery', path: '/amaron-products?category=car' },
        { name: 'Inverter Battery', path: '/amaron-products?category=inverter' },
        { name: 'Solar Battery', path: '/amaron-products?category=solar' }
      ]
    },
    {
      name: 'Lithium',
      path: '/lithium-products',
      icon: 'fa-battery-full',
      subcategories: [
        { name: 'Torque Lithium Batteries', path: '/lithium-products?category=torque-lithium' },
        { name: 'Solar Solutions', path: '/lithium-products?category=solar-solutions' },
        { name: 'Wall-Mounted Inverters', path: '/lithium-products?category=wall-mounted' }
      ]
    },
    {
      name: 'Solar',
      path: '/solar-products',
      icon: 'fa-solar-panel',
      subcategories: [
        { name: 'Solar Panels', path: '/solar-products?category=panels' },
        { name: 'Solar Inverters', path: '/solar-products?category=inverters' },
        { name: 'Solar Batteries', path: '/solar-products?category=batteries' },
        { name: 'Charge Controllers', path: '/solar-products?category=controllers' }
      ]
    }
  ];

  return (
    <div className="container-fluid nav-bar p-0" style={{ position: 'sticky', top: 0, zIndex: 1030, boxShadow: '0 2px 4px rgba(0,0,0,0.1)' }}>
      <div className="row gx-0 px-3 px-lg-5 align-items-center" style={{ backgroundColor: '#DE400E' }}>
        <div className="col-lg-3 d-none d-lg-block">
          <nav className="navbar navbar-light position-relative" style={{ width: '100%' }}>
            <button
              className="navbar-toggler border-0 fs-4 w-100 px-0 text-start"
              type="button"
              onClick={() => setActiveCategory(activeCategory === 'all-categories' ? null : 'all-categories')}
              style={{ background: 'none', color: '#fff', cursor: 'pointer' }}
            >
              <h4 className="m-0" style={{ color: '#fff', fontWeight: 'bold' }}>
                <i className="fa fa-bars me-2"></i>All Categories
              </h4>
            </button>
            
            {activeCategory === 'all-categories' && (
              <div className="navbar-collapse rounded-bottom show categories-dropdown" id="allCat">
                <div className="navbar-nav ms-auto py-0">
                  <ul className="list-unstyled categories-bars m-0">
                    {categories.map((category, index) => (
                      <li 
                        key={index} 
                        className="category-item"
                        onMouseEnter={() => setHoveredCategory(category.name)}
                        onMouseLeave={() => setHoveredCategory(null)}
                      >
                        <div className="categories-bars-item d-flex align-items-center justify-content-between">
                          <Link 
                            to={category.path} 
                            className="d-flex align-items-center flex-grow-1"
                            onClick={() => setActiveCategory(null)}
                            style={{ textDecoration: 'none', color: '#333' }}
                          >
                            <i className={`fas ${category.icon} me-2`} style={{ width: '20px' }}></i>
                            <span style={{ fontWeight: '500' }}>{category.name}</span>
                          </Link>
                          {category.subcategories.length > 0 && (
                            <span className="arrow ms-2" style={{ cursor: 'pointer', minWidth: '24px', textAlign: 'center' }}>›</span>
                          )}
                        </div>
                        
                        {hoveredCategory === category.name && category.subcategories.length > 0 && (
                          <div className="submenu-wrapper">
                            <ul className="list-unstyled categories-submenu m-0">
                              {category.subcategories.map((sub, subIndex) => (
                                <li key={subIndex} className="submenu-item">
                                  <Link 
                                    to={sub.path} 
                                    onClick={() => setActiveCategory(null)}
                                    className="d-block"
                                  >
                                    <i className="fas fa-chevron-right me-2"></i>
                                    {sub.name}
                                  </Link>
                                </li>
                              ))}
                            </ul>
                          </div>
                        )}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            )}
          </nav>
        </div>
        
        <div className="col-12 col-lg-9">
          <nav className="navbar navbar-expand-lg navbar-light" style={{ backgroundColor: '#DE400E' }}>
            <Link to="/" className="navbar-brand d-block d-lg-none">
              <img src="/assets/galaxy-logo-white.png" alt="Logo" style={{ height: '50px', width: 'auto' }} />
            </Link>
            
            <button
              className="navbar-toggler ms-auto"
              type="button"
              onClick={handleNavCollapse}
              aria-expanded={!isNavCollapsed}
              style={{ border: 'none', outline: 'none' }}
            >
              <span className="fa fa-bars fa-1x" style={{ color: '#fff' }}></span>
            </button>
            
            <div className={`collapse navbar-collapse ${!isNavCollapsed ? 'show' : ''}`} id="navbarCollapse">
              <div className="navbar-nav ms-auto py-0">
                <Link to="/" className="nav-item nav-link active" onClick={() => setIsNavCollapsed(true)}>
                  Home
                </Link>
                <Link to="/about" className="nav-item nav-link" onClick={() => setIsNavCollapsed(true)}>
                  About Us
                </Link>
                <Link to="/gallery" className="nav-item nav-link" onClick={() => setIsNavCollapsed(true)}>
                  Gallery
                </Link>
                <Link to="/video" className="nav-item nav-link" onClick={() => setIsNavCollapsed(true)}>
                  Video
                </Link>
                <Link to="/contact" className="nav-item nav-link me-2" onClick={() => setIsNavCollapsed(true)}>
                  Contact
                </Link>
                
                {/* Mobile Categories Dropdown */}
                <div className="nav-item d-block d-lg-none mb-3">
                  <a 
                    href="#!" 
                    className="nav-link d-flex align-items-center" 
                    onClick={(e) => {
                      e.preventDefault();
                      setActiveCategory(activeCategory === 'mobile-categories' ? null : 'mobile-categories');
                    }}
                    style={{ color: '#fff' }}
                  >
                    <i className="fa fa-bars me-2"></i>
                    All Categories
                    <i className={`fas fa-chevron-${activeCategory === 'mobile-categories' ? 'up' : 'down'} ms-2`} style={{ fontSize: '12px' }}></i>
                  </a>
                  
                  {activeCategory === 'mobile-categories' && (
                    <div className="mobile-categories-menu" style={{ 
                      backgroundColor: 'rgba(0, 0, 0, 0.15)', 
                      borderRadius: '8px', 
                      marginTop: '5px',
                      overflow: 'hidden'
                    }}>
                      {categories.map((category, index) => (
                        <Link 
                          key={index}
                          to={category.path} 
                          className="d-flex align-items-center"
                          onClick={() => {
                            setActiveCategory(null);
                            setIsNavCollapsed(true);
                          }}
                          style={{ 
                            textDecoration: 'none', 
                            color: '#fff',
                            padding: '10px 15px',
                            borderBottom: index < categories.length - 1 ? '1px solid rgba(255,255,255,0.15)' : 'none',
                            transition: '0.3s',
                            display: 'flex',
                            alignItems: 'center'
                          }}
                          onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = 'rgba(0,0,0,0.2)'; }}
                          onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = 'transparent'; }}
                        >
                          <i className={`fas ${category.icon} me-3`} style={{ width: '20px', textAlign: 'center' }}></i>
                          <span style={{ flex: 1, fontWeight: '500' }}>{category.name}</span>
                          <i className="fas fa-chevron-right" style={{ fontSize: '11px', opacity: 0.7 }}></i>
                        </Link>
                      ))}
                    </div>
                  )}
                </div>
              </div>
              
              <a 
                href="tel:+919865757472" 
                className="btn btn-light rounded-pill py-2 px-4 px-lg-3 mb-3 mb-md-3 mb-lg-0"
                onClick={() => setIsNavCollapsed(true)}
                style={{ 
                  backgroundColor: '#fff', 
                  color: '#DE400E',
                  fontWeight: 'bold',
                  border: 'none'
                }}
              >
                <i className="fa fa-mobile-alt me-2"></i> +91 98657 57472
              </a>
            </div>
          </nav>
        </div>
      </div>
    </div>
  );
};

export default Navbar;